<template>
  <v-container fill-height class="align-start align-sm-center mt-10 mt-sm-0">
    <v-form id="loginForm" ref="loginForm" v-model="isValid" @submit.prevent="submit">
      <v-card class="elevation-12">
        <v-toolbar color="primary" dense dark flat>
          <v-toolbar-title>{{$t('Login')}}</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          <div class="flex">
            <div>
              <v-text-field
                type="text"
                :label="$t('Username')"
                v-model="username"
                name="username"
                required
                :rules="[requiredRule]"
                prepend-icon="person"
              ></v-text-field>
              <v-text-field
                :label="$t('Password')"
                v-model="password"
                name="password"
                required
                :rules="[requiredRule]"
                :type="showPwd ? 'text' : 'password'"
                :append-icon="showPwd ? 'visibility_off' : 'visibility'"
                prepend-icon="lock"
                @click:append="showPwd = !showPwd"
              ></v-text-field>
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit">{{$t('Login')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<style lang="scss" scoped>
#loginForm {
  width: 375px;
  margin: auto;
}
</style>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      isValid: false,
      username: "",
      password: "",
      showPwd: false,
      requiredRule: v => !!v || this.$t("This field is required!")
    };
  },
  computed: {
    ...mapState("account", ["status"])
  },

  methods: {
    ...mapActions("account", ["login"]),

    submit() {
      if (this.$refs.loginForm.validate()) {
        this.showPwd = false;
        this.login({ username: this.username, password: this.password });
      }
    }
  }
};
</script>
